import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "창작",
  icon: "✨",
  templates: [
    {
      title: "잠자리 동화",
      content: `어린 아이를 위한 부드러운 잠자리 동화를 소리 내어 읽기에 적합하게 작성해 주세요.
- 주인공은 [착한 작은 여우]이며 이름은 [헤이즐]입니다.
- 이야기는 [밤이면 등불이 빛나는 아늑한 숲속 마을]에서 펼쳐집니다.
- 주인공은 작고 편안한 도전에 직면합니다: [구름 낀 하늘에서 가장 좋아하는 별을 찾지 못해 반딧불이를 따라 언덕 꼭대기까지 갑니다].
- [인내심과 좋은 것들이 보이지 않아도 여전히 거기 있다는 믿음]을 가르치는 평화로운 결말로 마무리해 주세요.
- 소리 내어 읽을 때 자연스럽게 들리는 짧고 리듬감 있는 문장을 사용해 주세요.`
    },
    {
      title: "단편 소설 내레이션",
      content: `오디오북 스타일 내레이션에 적합한 단편 소설을 작성해 주세요.
- 장르: [현대 미스터리].
- 주인공은 [새 이웃의 일상에서 이상한 점을 발견한 은퇴한 사서]입니다.
- 핵심 긴장감은 [설명할 수 없는 작은 디테일들이 쌓여 놀랍지만 만족스러운 반전으로 이어지는 것]입니다.
- 톤: [따뜻함이 감도는 조용한 서스펜스].
- 청취자의 관심을 유지하기 위해 문장 길이를 다양하게 하며 명확하고 유려한 스타일로 작성해 주세요.`
    },
    {
      title: "시 낭독",
      content: `소리 내어 낭독하기 위한 시를 작성해 주세요.
- 주제: [새벽에 깨어나는 도시의 느낌].
- 스타일: [자연스러운 말하기 리듬을 가진 자유시].
- 분위기: [성찰적이고 희망적인].
- 생생한 감각적 묘사를 포함해 주세요: [첫 버스 소리, 젖은 보도에 비치는 빛, 빵집에서 풍기는 갓 구운 빵 냄새].
- 독자의 호흡과 페이스를 안내하는 쉼과 행 나눔을 사용해 주세요.`
    }
  ]
};
